export default {"src":"/_next/static/media/ic_close_button.6d8013ec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};